/** Regular list price (MRP / was price). */
export function productRegularPrice(product) {
  return Math.max(0, Number(product?.price) || 0);
}

/** Sale price when valid; otherwise null. */
export function productSalePrice(product) {
  const regular = productRegularPrice(product);
  const raw = product?.sale_price;
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }
  const sale = Number(raw);
  if (!Number.isFinite(sale) || sale <= 0 || regular <= 0 || sale >= regular) {
    return null;
  }
  return sale;
}

/** Price used for cart and checkout. */
export function productEffectivePrice(product) {
  const sale = productSalePrice(product);
  return sale ?? productRegularPrice(product);
}

export function productOnSale(product) {
  return productSalePrice(product) !== null;
}

export function productDiscountPercent(product) {
  const regular = productRegularPrice(product);
  const sale = productSalePrice(product);
  if (!sale || regular <= 0) return 0;
  return Math.round((1 - sale / regular) * 100);
}

/**
 * Compute sale_price for admin save from optional sale price or percent off regular.
 * @returns {number|null}
 */
export function computeSalePriceForSave(regular, { onSale, salePrice, salePercent }) {
  if (!onSale || regular <= 0) return null;
  const pct = Number(salePercent);
  if (Number.isFinite(pct) && pct > 0) {
    const p = Math.min(99.99, Math.max(0.01, pct));
    const computed = Math.round(regular * (1 - p / 100) * 100) / 100;
    return computed > 0 && computed < regular ? computed : null;
  }
  const sp = Number(salePrice);
  if (Number.isFinite(sp) && sp > 0 && sp < regular) {
    return Math.round(sp * 100) / 100;
  }
  return null;
}
